import configuration from "../utilities/config/configuration";

export enum EndpointEnum {
    entitlementMetadata = '/user-management/entitlements/metadata',
    entitlementMetadataRelations = '/user-management/entitlements/metadata/table',
    apiKeyList= '/user-management/apiKeys',
    apiKeyCreate = '/user-management/apiKey',
    apiKeyDelete = '/user-management/apiKey/:keyId',
    entitlementList = '/user-management/entitlements',
    entitlementUpdate = '/user-management/entitlement',
    entitlementDeletePerUser = '/user-management/entitlement/:userId',
    entitlementDelete= '/user-management/entitlement/:userId/:productId',
    entitlementCreate = '/user-management/entitlement',
    entitlementCreateList = '/user-management/entitlements',
    createProduct = '/user-management/product',
    updateProduct = '/user-management/product/:productId',
    getProductList = '/user-management/products',
    deleteProduct = '/user-management/product/:productId',
    getProduct = '/user-management/product/:productId',
    exportProduct = '/user-management/product/export',
    userList = '/user-management/users',
    adminUserList = '/user-management/admins',
    userCreate = '/user-management/user',
    userListExport = '/user-management/users/export',
    userListImport = '/user-management/users/import',
    ownUserUpdate = '/user-management/user',
    checkUserInitialSetup = '/user-management/user/me',
    userGet = '/user-management/user/:userId',
    userDelete = '/user-management/user/:userId',
    userPut = '/user-management/user/:userId',
    loggedUserEntitlements = '/user-management/user/entitlements',
    widgetList = '/user-management/widgets',
    widgetCreate = '/user-management/widget',
    widgetUpdate = '/user-management/widget/:widgetId',
    widgetDelete = '/user-management/widget/:widgetId',
    widgetActivate = '/user-management/widget/activate/:widgetId',
    widgetDeactivate = '/user-management/widget/deactivate/:widgetId',
    widgetGet = '/user-management/widget/:widgetId',
    initBackendRequest = '/user-management/init/request',
    googleBucketPrefixUrl= 'https://storage.googleapis.com',
    customizedSolutionWidgetConfig= '/user-management/mdwidget/customized-solution/customized-solution.html',
    //customizedSolutionWidgetConfig= '/user-management/mdwidget/customized-solution/:filename',
    fileservice = '/user-management/fileservice',
    fileDownload = '/user-management/fileservice/download',
    fileDownloadFiles = '/user-management/fileservice/download/files',
    billingList = '/user-management/billings',
}
export enum RoutesEnum {
    home = '/',
    apiSpecifications = '/api/overview',
    main = 'main',
    dashboards = 'dashboards',
    dash= 'dash',
    files= '/files',
    management = '/management',
    loginRequired = '/*',
    entitlements = 'entitlements',
    users = 'users',
    admins = 'admins',
    products = 'products',
    billing = 'billing',
    widgets = 'widgets',
    widgetCreate = 'widgets/create',
    widgetEdit = 'widgets/edit/:widgetId',
    createProduct = 'product/create',
    editProduct = 'product/edit/:productId',
    viewProduct = 'product/view/:productId',
    notFound = 'not-found',
  }
export enum PageName{
    home = 'Home',
    dashboards = 'Dashboards',
    files = 'FILE SERVICE',
    management = 'Management',
    loginRequired = 'Login Required',
    entitlements = 'Entitlements',
    users = 'Users',
    products = 'Products',
    billing = 'Billing',
    widgets = 'Widgets',
    widgetCreate = 'Create Widget',
    widgetEdit = 'Edit Widget',
    createProduct = 'Create Product',
    editProduct = 'Edit Product',
    viewProduct = 'View Product',
    apiKey= 'API Key',
    myProducts = 'My Products',
}

export enum RoleName{
    user = 'User',
    operations = 'Business Operations',
    widgets = 'Widgets',
    entitlement = 'Entitlement',
}

export const WidgetConstants = {
    typo3BaseUrl: '/fileadmin/EEX/Market_Data/MarketDataHub',
    fullWidgetBucketUrl: `${configuration.widgetBaseUrl}`,
    widgetConfigDir: '/widget-config',
    customizedWidgetVariable_WIDGET_CODE: 'WIDGET_CODE',
    customizedWidgetVariable_WIDGET_CONFIG: 'WIDGET_CONFIG',
    customizedWidgetVariable_INIT_WIDGET_CONFIG: 'INIT_WIDGET_CONFIG',
    customizedWidgetVariable_CUSTOMIZED_SOLUTION_READY: 'CUSTOMIZED_SOLUTION_READY',
    customizedWidgetVariable_SHARE_WIDGET: 'SHARE_WIDGET',
};

export enum WidgetStatus {
    active = 'active',
    deactivated = 'deactivated',
}

export enum IDPProvider {
    openAM = 'OpenAM',
    entraId = 'EntraId',
    cognito = 'Cognito',
}

export enum OpenAMRoles {
    user = 'user',
    operations = 'operations',
    widgets = 'widgets',
    entitlement = 'entitlement',
}

export enum ProductFeatureAlias {
  api = 'service',
}

export enum FileServiceLabelAliases {
    idx = 'Index',
    rd = 'Reference Data',
    rev = 'Revenue',
    rslt = 'Results',
    spr = 'Settlement Price',
    stat = 'Statistics',
    tob = 'TopOfBook',
    trd = 'Trades',
}

export enum ServiceName {
  RestApi = 'rest-api',
  FileCloud = 'file-cloud',
}